import Typography from "typography";

const typography = new Typography({
  baseFontSize: '15px',
  baseLineHeight: 1.666,
  headerFontFamily: ['Source Sans Pro', 'Helvetica Neue', 'Segoe UI', 'Helvetica', 'Arial', 'sans-serif'],
  bodyFontFamily: ['Avenir Next'],
  // See below for the full list of options.
})

export default typography;
